import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { TextInput } from "@/components";
import { ContainedButton } from "@/common";

export const IconBox = styled(Box)(() => ({
  backgroundColor: "#E8E8E8",
  height: "36px",
  width: "36px",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "& svg": {
    color: "#052223",
  },
}));

export const IconBoxMain = styled(Box)({
  display: "flex",
  alignItems: "center",
});
export const StyledTextInput = styled(TextInput)({
  borderColor: "#C0C4C4",
  backgroundColor: "#fff",
  borderRadius: "6px",
});
export const StyledContainedButton = styled(ContainedButton)({
  height: "100%",
  borderRadius: "6px",
});

export const HeaderRightNode = styled(Box)({
  display: "flex",
  width: "50%",
  justifyContent: "end",

  "@media (max-width: 1380px)": {
    width: "70%",
  },
  "@media (max-width: 1000px)": {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
});
export const HeaderSearchBox = styled(Box)({
  width: "39%",
  "@media (max-width: 1380px)": {
    width: "35%",
  },
});
